define([
	"dojo/_base/declare",
	"csi",
	"csi/table/New",
	"csi/xml"
], function (declare, csi, New, xml) {

	return declare(New, {
		toWriter: function (fd) {
			var call = this.inherited(arguments);
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("UserType", xml.ATTR_ENUM, xml.enumCreate("UserType", "CustomService"))
				.changeAttribute("EnableMobileApp", xml.ATTR_BOOLEAN, false, null, null, "0x1")
				.changeAttribute("Image", xml.ATTR_REF, csi.EMPTY_URL, null, null, "0x1");
		}
	});
});